import { Component, Input, OnInit } from '@angular/core';
import {
  ModalController,
  Platform,
  PopoverController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Clipboard } from '@capacitor/clipboard';
import { SharingService } from 'src/services/NativeSharing.service';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import { GmbInitialComponent } from '../gmb-initial-component/gmb-initial-component';
import { Router } from '@angular/router';
import { Browser } from '@capacitor/browser';

@Component({
  selector: 'boxx-qr-popover',
  templateUrl: './qr-popover.component.html',
  styleUrls: ['./qr-popover.component.scss'],
})
export class QrPopoverComponent implements OnInit {
  @Input() websiteUrlString: string;
  @Input() gmbUrlString: string;
  @Input() openQRFirstTime: boolean; 
  @Input() hasGBPSync: boolean; 
  @Input() showWizardItem: boolean;
  @Input() urlType: string;

  isCordovaOrCapacitor = false;

  folderpath: string;
  isAndroid: boolean;

  translations: any;
  allowSharingButton = true;
  QRMessage: string;

  destroyed$ = new Subject<boolean>();

  constructor(
    public platform: Platform,
    private popoverCtrl: PopoverController,
    private translate: TranslateService,
    private shareSrvc: SharingService,
    private boxxUtils: BoxxUtilsService,
    private sharingService: SharingService,
    public storageService: LocalStorageNativeService,
    private modalCtrl: ModalController,
    private router: Router
  ) {
    this.translate
      .get(['QR', 'CLIPBOARD', 'PANEL_VIEW'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));

    this.platform.ready().then(() => {
      this.isCordovaOrCapacitor =
        this.platform.is('cordova') || this.platform.is('capacitor');

      if (this.platform.is('android')) {
        this.isAndroid = true;
      } else {
        this.isAndroid = false;
      }

      this.allowSharingButton =
        !this.platform.is('desktop') && !this.platform.is('mobileweb');
    });
  }

  ngOnInit() {
    if (this.openQRFirstTime) {console.log('this.urlType: ', this.urlType);
      if(this.urlType === 'agency_website'){
        this.QRMessage = this.translations.PANEL_VIEW.WIDGET.QR.alternativeTitle;
      }
      else if(this.urlType === 'shop'){  
        this.QRMessage = this.translations.PANEL_VIEW.WIDGET.QR.alternativeTitleStore;
      }
      else if(this.urlType === 'directory'){ 
        this.QRMessage = this.translations.PANEL_VIEW.WIDGET.QR.alternativeTitleDirectory;
      }
      
    }
    else{
      setTimeout(async () => {
        this.QRMessage = this.translations.PANEL_VIEW.WIDGET.QR.mainTitle;
      }, 100);
    }
  
  }

  async close() {
    this.popoverCtrl.dismiss();

    const obDataStr = await this.storageService.getItem('first_load_modal');
    if (!obDataStr || obDataStr === null) {
      if(!this.hasGBPSync){
        this.storageService.getItem('gmbTotalPlayQuestion').then(async haveQuestion => {
          await this.storageService.setItem('gmbTotalPlayQuestion', true);
            if (!haveQuestion) {
              const allowClose = true;
              const view = await this.modalCtrl.create({
                component: GmbInitialComponent,
                componentProps: { allowClose },
                backdropDismiss: false,
              });
              view.present();

              const { data } = await view.onDidDismiss();
              if (!data) {

                if(this.showWizardItem){
                  this.router.navigateByUrl('onboarding/business-configuration', {
                    state: { isLoginUser: true },
                  });
                }

              }
              else{
                if(this.showWizardItem){
                  this.router.navigateByUrl('onboarding/business-configuration', {
                    state: { isLoginUser: true },
                  });
                }
              }

            }                 
        });
      }
      
      setTimeout(async () => {
        await this.storageService.setItem('first_load_modal', true);
      }, 1000);
    }
    
  }

  /**
   * Convert a base64 string in a Blob according to the data and contentType.
   *
   * @param b64Data Pure base64 string without contentType
   * @param contentType the content type of the file i.e (image/jpeg - image/png - text/plain)
   * @param sliceSize SliceSize to process the byteCharacters
   * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
   * @return Blob
   */
  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  scaleImage(
    base64Data: string,
    width: number,
    height: number
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        // We create a canvas and get its context.
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // We set the dimensions at the wanted size.
        canvas.width = width;
        canvas.height = height;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(img, 0, 0, width, height);

        resolve(canvas.toDataURL());
      };

      img.onerror = (e) => {
        reject(e.toString());
      };

      img.src = base64Data;
    });
  }

  // source: https://davidwalsh.name/javascript-download
  downloadFile(data, fileName, type = 'text/plain') {
    // Create an invisible A element
    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);

    // Set the HREF to a Blob representation of the data to be downloaded
    a.href = window.URL.createObjectURL(new Blob([data], { type }));

    // Use download attribute to set set desired file name
    a.setAttribute('download', fileName);

    // Trigger the download by simulating click
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
  }

  async openUrl() {
    //window.open(this.websiteUrlString, '_system');
    await Browser.open({ url: this.websiteUrlString });
  }

  shareUrl() {
    const shareUrlOptions = {
      url: this.websiteUrlString,
    };
    this.shareSrvc.socialSharing(shareUrlOptions);
  }

  async copyUrl() {
    if (this.platform.is('desktop') || this.platform.is('mobileweb')) {
      if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(this.websiteUrlString).then(
            () => {
              this.boxxUtils.showToastSuccess({
                message: this.translations.CLIPBOARD.urlCopiedToClipboard,
              });
            },
            () => {
              this.boxxUtils.showToastError({
                message: this.translations.CLIPBOARD.urlCopiedToClipboardError,
              });
            }
          );
        } catch (err) {
          this.boxxUtils.showToastError({
            message: this.translations.CLIPBOARD.urlCopiedToClipboardError,
          });
        }
      }
    } else {
      Clipboard.write({
        string: this.websiteUrlString
      }).then(
        () => {
          this.boxxUtils.showToastSuccess({
            message: this.translations.CLIPBOARD.urlCopiedToClipboard,
          });
        },
        () => {
          this.boxxUtils.showToastError({
            message: this.translations.CLIPBOARD.urlCopiedToClipboardError,
          });
        }
      );
    }
  }

  openBusinessLocation() {
    this.sharingService.openURL(this.gmbUrlString);
  }
}
